const countdownSelector = '.essential_countdown_annoucement_bar_wrapper.top_page';
const root = document.documentElement;
let countdownResizeObserver;

function updateCountdownOffset() {
  const countdown = document.querySelector(countdownSelector);
  const isVisible = countdown && countdown.getClientRects().length > 0;
  const position = countdown ? getComputedStyle(countdown).position : '';
  const isOverlay = position === 'sticky' || position === 'fixed';
  const height = isVisible && isOverlay ? Math.ceil(countdown.getBoundingClientRect().height) + 12 : 0;

  root.style.setProperty('--bigiti-countdown-offset', `${height}px`);

  countdownResizeObserver?.disconnect();

  if (countdown) {
    countdownResizeObserver = new ResizeObserver(updateCountdownOffset);
    countdownResizeObserver.observe(countdown);
  }
}

const countdownMutationObserver = new MutationObserver(updateCountdownOffset);

countdownMutationObserver.observe(document.documentElement, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['class', 'style', 'hidden']
});

window.addEventListener('resize', updateCountdownOffset, { passive: true });
window.addEventListener('pageshow', updateCountdownOffset);
document.addEventListener('DOMContentLoaded', updateCountdownOffset);
updateCountdownOffset();
